<!--
 * @Author: Yang Zhang
 * @Date: 2021-11-22 11:47:05
 * @LastEditors: zhangyang yang.zhang@corerain.com
 * @LastEditTime: 2023-03-22 11:15:08
 * @Description:
-->
<template>
  <a-layout>
    <PageHeader :list="routeList" />
    <a-layout class="page-main">
      <AsideBar :list="menuList" />
      <a-layout class="page-right">
        <router-view v-slot="{ Component }">
          <transition name="fade-slide" mode="out-in" appear>
            <component :is="Component" />
          </transition>
        </router-view>
      </a-layout>
    </a-layout>
  </a-layout>
</template>

<script lang="ts">
// @ts-ignore
import { defineComponent, watch, reactive, onMounted, ref, computed } from 'vue'
import { PageHeader, AsideBar } from '@/components'
import routeList from '@/router/routes'
import { useStore } from 'vuex'
import { RouterNameEnum } from '@/enums/routerEnum'
import { useRoute } from 'vue-router'

const { BASE_SERVER_ROUTER_NAME, OPERATE_CENTER } = RouterNameEnum

export default defineComponent({
  components: {
    PageHeader,
    AsideBar
  },
  setup() {
    const store = useStore()
    const route = useRoute()
    const sideBarMenus = store.state.user.sideBarMenu
    const newRoute = ref('')
    const hasOperateRoute = sideBarMenus[OPERATE_CENTER].filter(
      (item) => (item.children && item.children.length) || (!item.children && !item.meta.isHideMenu)
    )
    const hasBaseRoute = sideBarMenus[BASE_SERVER_ROUTER_NAME].filter(
      (item) => (item.children && item.children.length) || (!item.children && !item.meta.isHideMenu)
    )
    newRoute.value =
      hasOperateRoute && hasOperateRoute.length
        ? OPERATE_CENTER
        : hasBaseRoute && hasBaseRoute.length
        ? BASE_SERVER_ROUTER_NAME
        : ''
    const menuList = computed(() =>
      newRoute.value
        ? store.state.user.sideBarMenu[(route.meta.activeMenu || newRoute.value) as any]
        : []
    )
    return {
      menuList
    }
  },
  data() {
    return {
      routeList,
      rootPath: '/base-server'
    }
  },
  methods: {
    getMenuList() {
      let arr: any[] = []
      routeList.forEach((item: any) => {
        if (item.path === this.rootPath) {
          arr = item.children
        }
      })

      arr = arr.filter((item: any) => item.path !== '')

      return arr
    }
  }
})
</script>

<style lang="less">
/* fade-slide */
.fade-slide-leave-active,
.fade-slide-enter-active {
  transition: all 0.3s;
}

.fade-slide-enter-from {
  opacity: 0;
  transform: translateX(-30px);
}

.fade-slide-leave-to {
  opacity: 0;
  transform: translateX(30px);
}
</style>
